<header class="flex items-center">
  <button
    type="button"
    class="border-0 bg-transparent p-0"
    [class.cursor-pointer]="isDevelopment"
    [class.cursor-default]="!isDevelopment"
    (click)="onImageClick()"
    aria-label="BlazeBite"
  >
    <img
      src="assets/logos/blazebite_dark.png"
      alt="BlazeBite logo"
      title="{{ buildInfo }}"
      class="h-9 w-auto"
    >
  </button>
</header>

<app-debug-local-storage
  [isVisible]="showDebugModal"
  (closed)="onDebugModalClose()">
</app-debug-local-storage>
